import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaPause } from 'react-icons/fa6';
import CustomPrimaryButton from './CustomPrimaryButton';
import { FaPlay } from 'react-icons/fa';

/**
 * A reusable component to play audio with a toggle button and external control for pausing.
 *
 * @param {string} audioSrc - The source URL of the audio file.
 * @param {boolean} shouldPause - Indicates if the audio should pause due to an external condition.
 */
const LessonAudio = ({ audioSrc, shouldPause }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (audioSrc && audioRef.current && !shouldPause) {
      audioRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch((err) => {
        console.error("Auto-play failed:", err);
      });
    }

    if (shouldPause && audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, [audioSrc, shouldPause]);

  const handleToggleAudio = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="lesson-audio-container">
      <audio ref={audioRef} src={audioSrc} preload="metadata" />
      <CustomPrimaryButton
        btnTextPro={isPlaying ? <FaPause size={30} /> : <FaPlay size={30} />}
        handleOnClick={handleToggleAudio}
      />
    </div>
  );
};

LessonAudio.propTypes = {
  audioSrc: PropTypes.string.isRequired,
  shouldPause: PropTypes.bool.isRequired,
};

export default LessonAudio;
